import { Steps, Modal, Switch, Typography } from "antd";
import { useState } from "react";

const WorkerStatus = ({
  ref1,
  is_worker_active,
  active_device,
  updateUser,
}) => {
  const [is_open_confirm_modal, setOpenConfirmModal] = useState(false);
  const is_device_active = !!active_device;

  const handleActivateUser = async () => {
    await updateUser({
      is_active: !is_worker_active,
    });
    setOpenConfirmModal(false);
  };

  return (
    <>
      <Modal
        style={{ top: 45 }}
        title="Potwierdzenie"
        open={is_open_confirm_modal}
        onCancel={() => setOpenConfirmModal(false)}
        okText="Tak"
        cancelText="Nie"
        onOk={handleActivateUser}
      >
        <p>
          Czy na pewno chcesz {is_worker_active ? "dezaktywować" : "aktywować"}{" "}
          pracownikowa?
        </p>
      </Modal>
      <Steps
        className="worker-steps"
        style={{ marginBottom: 20, padding: "0 20px" }}
        items={[
          {
            title: "Krok 1 - Aktywny pracownik",
            status: is_worker_active ? "finish" : "error",
            description: (
              <div style={{ paddingBottom: 10 }}>
                <Typography.Text type="secondary">
                  W pierwszym kroku należy aktywować pracownika, klikając w
                  przycisk "Aktywuj" znajdujący sie poniżej.
                </Typography.Text>

                <div className="m-t-10">
                  <Switch
                    ref={ref1}
                    checkedChildren="Aktywny"
                    unCheckedChildren="Nieaktywny"
                    checked={is_worker_active}
                    onChange={() => {
                      if (is_worker_active) {
                        setOpenConfirmModal(true);
                      } else {
                        handleActivateUser();
                      }
                    }}
                  />
                </div>
              </div>
            ),
          },
          {
            title: "Krok 2 - Aktywne urządzenie",
            status: is_device_active ? "finish" : "error",
            description: (
              <Typography.Text type="secondary">
                W drugim kroku należy aktywować urządzenie, klikając w przycisk
                "Odblokuj" znajdujący się poniżej na liście dostępnych urządzeń.
                <br />
                <strong>Urządzenie: {active_device?.device?.name}</strong>
              </Typography.Text>
            ),
          },
          {
            title:
              is_worker_active && is_device_active
                ? "Status odblokowany"
                : "Status zablokowany",
            status: is_worker_active && is_device_active ? "finish" : "error",
            description: (
              <Typography.Text type="secondary">
                {is_worker_active && is_device_active
                  ? "Aktywacja przebiegła pomyślnie."
                  : "Aby oblokować trzeba aktywować pracownika i urządzenie."}
              </Typography.Text>
            ),
          },
        ]}
      />
    </>
  );
};

export default WorkerStatus;
